import { render, staticRenderFns } from "./JoinUpNow.vue?vue&type=template&id=784dd262&"
import script from "./JoinUpNow.vue?vue&type=script&lang=js&"
export * from "./JoinUpNow.vue?vue&type=script&lang=js&"
import style0 from "./JoinUpNow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports